import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import { useMantineTheme } from '@mantine/core';
import 'mapbox-gl/dist/mapbox-gl.css';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { DataFormats } from 'utils/constants';

mapboxgl.accessToken = process.env.REACT_APP_MB_TOKEN_DARK;

export const MapDisplay = (props) => {
    // const {lat,lng} = props;
    const mapContainer = useRef(null);
    const map = useRef(null);
    const [lng, setLng] = useState(props.lng ? parseFloat(props.lng) : 144.9355232);
    const [lat, setLat] = useState(props.lat ? parseFloat(props.lat) : -37.822913);
    const [zoom, setZoom] = useState(9);
    const theme = useMantineTheme();

    const allowZoom = props.allowZoom !== undefined ? props.allowZoom : true;

    useEffect(() => {
        if (props.lat && props.lng) {
            setLat(props.lat);
            setLng(props.lng);

            if(map.current){
                const marker1 = new mapboxgl.Marker({ color: 'black' }).setLngLat([props.lng, props.lat]).addTo(map.current);
            
                new mapboxgl.Popup({
                    closeButton:false,
                    offset:[0,-120],
                    className:'location-popup'
                }).setLngLat([props.lng+10, props.lat]).setHTML(`<div style="text-align:center; color:black"><strong>${props.location}</strong><br>
                ${moment(props.created).format(DataFormats.DATE_FORMAT)}</div>`).addTo(map.current);
    
                map.current.flyTo({
                    center: [props.lng, props.lat],
                    zoom: 12,
                    essential: true, // this animation is considered essential with respect to prefers-reduced-motion
                });
            }
            
        }
    }, [props.lat,map.current]);

    useEffect(() => {
        if (map.current) return; // initialize map only once
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/streets-v12',
            center: [lng, lat],
            zoom: zoom,
            scrollZoom: allowZoom,
            doubleClickZoom: allowZoom,
            touchZoomRotate: allowZoom,
            boxZoom: allowZoom,
        });
    }, []);

    return <div ref={mapContainer} className='map-container' style={{ height: props.height, width: props.width, borderRadius: theme.radius.md }} />;
};
